let originalIframes = [];
let iframePlaceholder = document.getElementById('iframe_placeholder').cloneNode(true);
iframePlaceholder.classList.remove('hidden');
// remove the id from the placeholder, since we want the id only for the template
iframePlaceholder.removeAttribute('id');

export function blockIframes() {
    return new Promise((resolve) => {
        // loop over all iframes, and put them into the originalIframes array
        document.querySelectorAll('iframe').forEach(function(iframe) {
            originalIframes.push(iframe);
            // Replace the iframe with a placeholder
            if (iframe.parentElement.classList.contains('relative')) {
                iframePlaceholder.classList.add('absolute');
            } else if (iframePlaceholder.classList.contains('absolute')) {
                iframePlaceholder.classList.remove('absolute');
            }

            // loop over and add all the attributes of the original iframe, but prefix each with 'data-'
            // This is to preserve the original attributes to make debugging easier
            Array.from(iframe.attributes).forEach(attr => {
                iframePlaceholder.setAttribute('data-' + attr.name, attr.value);
            });

            // Find the first parent that is a section
            let parentSection = iframe.closest('section');
            // Check if the parent section has the class "site__container", this means that the
            // iframe is inside one of the JT sections, which we don't want to hide
            if (!parentSection || !parentSection.classList.contains('site__container')) {
                iframePlaceholder.classList.add('hidden');
            }

            iframe.parentNode.replaceChild(iframePlaceholder.cloneNode(true), iframe);
        });
        resolve(document.querySelectorAll('.iframe-placeholder'));
    })
}

export function unblockIframes() {
    document.querySelectorAll('.iframe-placeholder').forEach(function(iframePlaceholder) {
        // check for id on iframePlaceholder since this is the template
        if (iframePlaceholder.id !== 'iframe_placeholder') {
            iframePlaceholder.parentNode.replaceChild(originalIframes.shift(), iframePlaceholder);
        }
    })
}

export function isBlocked() {
    return originalIframes.length > 0;
}
